export const da = {
  returnRequestDate: {
    label: "Din returanmodning blev oprettet den {{date}} kl. {{time}}",
  },
  actions: {
    continue: "Fortsæt",
  },
  "order-identification": {
    title: "Spor din ordre",
    description: "Indtast dine ordreoplysninger for at spore din pakke",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Indtast dit leveringspostnummer",
        required: "Postnummer er påkrævet",
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Indtast dit ordrenummer",
        required: "Ordrenummer er påkrævet",
      },
    },
    errors: {
      "unknown-order": {
        title: "Ukendt ordrenummer",
        description: "Ordrenummeret blev ikke fundet, kontroller det venligst",
      },
      "search-error": {
        title: "Søgefejl",
        description: "Vi kunne ikke finde ordren. Prøv venligst igen senere.",
      },
    },
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorik",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Leveret den",
      from: "fra",
      to: "til",
    },
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse på afhentningssted:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:",
    },
  },
  pickupPoint: {
    title: "Afhentningssted",
    openingHours: "Åbningstider:",
    closed: "Lukket",
    directions: "Vejbeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "Lørdag:",
      sunday: "Søndag:",
    },
  },
  wallet: {
    warningNotEnabled: "Du skal aktivere Wallet i dine butiksindstillinger",
  },
  crossSell: {
    youMightAlsoLike: "Du vil måske også kunne lide",
  },
  "rate-order": {
    "order-recap": {
      title: "Din ordre",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:",
    },
    form: {
      title: "Bedøm din levering",
      "rating-label": "Bedøm din leveringsoplevelse",
      "comment-label": "Kommentar (valgfri)",
      "comment-placeholder": "Del din oplevelse med os…",
      "submit-cta": "Indsend min anmeldelse",
      "update-cta": "Opdater min anmeldelse",
      "rating-required": "Vælg venligst en bedømmelse.",
    },
    "thank-you": {
      title: "Tak for din feedback!",
      description:
        "Din anmeldelse er blevet gemt. Den vil hjælpe os med at forbedre leveringsoplevelsen.",
    },
    errors: {
      "invalid-token": {
        title: "Ugyldigt eller udløbet link",
        description:
          "Dette link er ikke længere gyldigt. Åbn det igen fra din seneste sporings-e-mail.",
      },
      submit: {
        title: "Noget gik galt",
        description:
          "Vi kunne ikke gemme din anmeldelse. Prøv venligst igen senere.",
      },
    },
  },
} as const;
